import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '../../stores/redux-store';
import { CredentialsEntity } from '../../models/credentials';
import { DebuggerInfoContainer, Info, Text } from './DebuggerInfo.styles';

export type DebuggerInfoProps = {
  credentials?: CredentialsEntity;
};

export const DebuggerInfoPresenter: React.FC<DebuggerInfoProps> = ({ credentials }) => {
  return (
    <DebuggerInfoContainer data-testid="debuggerinfo">
      <Info>
        <Text> {`Credential identifier: ${credentials?.id || 'null'}`}</Text>
      </Info>
    </DebuggerInfoContainer>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    credentials: state.credentials.data,
  };
};

export const DebuggerInfo = connect(mapStateToProps)(DebuggerInfoPresenter);
